<template>
    <header class="site-header">
        <div class="header-container">
            <Link href="/" class="logo">
                <img
                    src="/favicon-192x192.png"
                    :alt="brand"
                    width="36"
                    height="36"
                    decoding="async"
                />
            </Link>

            <nav class="main-nav" aria-label="Основное меню">
                <Link href="/" class="nav-link" :class="{ active: isActive('/') }">Главная</Link>
                <Link href="/results" class="nav-link" :class="{ active: isActive('/results') }">Результаты</Link>
                <Link href="/teams" class="nav-link" :class="{ active: isActive('/teams') }">Команды</Link>
                <Link href="/players" class="nav-link" :class="{ active: isActive('/players') }">Игроки</Link>
                <Link href="/coaches" class="nav-link" :class="{ active: isActive('/coaches') }">Тренеры</Link>
                <Link href="/referees" class="nav-link" :class="{ active: isActive('/referees') }">Судьи</Link>
            </nav>

            <div class="header-actions">
                <Link
                    href="/stats/advanced"
                    class="nav-link nav-link--advanced header-actions__desktop"
                    :class="{ active: isActive('/stats/advanced') }"
                >
                    <img
                        src="/images/icons/flammable.png"
                        alt=""
                        class="nav-link__icon"
                        width="18"
                        height="18"
                        decoding="async"
                    />
                    <span>Для продвинутых</span>
                </Link>

                <template v-if="authUser">
                    <div class="user-menu-wrapper header-actions__desktop">
                        <button
                            type="button"
                            class="btn-auth"
                            :aria-expanded="showUserMenu ? 'true' : 'false'"
                            @click="showUserMenu = !showUserMenu"
                        >
                            {{ authUser.surname || authUser.username }}
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                                <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                            </svg>
                        </button>
                        <div v-if="showUserMenu" class="user-dropdown">
                            <template v-if="authUser.is_admin">
                                <Link href="/admin/dvw" class="dropdown-item" @click="showUserMenu = false">Загрузить матч</Link>
                                <Link href="/admin/sheets-sync" class="dropdown-item" @click="showUserMenu = false">Sheets Sync</Link>
                                <div class="dropdown-divider" />
                            </template>
                            <template v-else>
                                <Link href="/profile" class="dropdown-item" @click="showUserMenu = false">Мой профиль</Link>
                                <Link
                                    v-if="authUser?.status === 'registered'"
                                    href="/player/stats"
                                    class="dropdown-item"
                                    @click="showUserMenu = false"
                                >
                                    Статистика
                                </Link>
                                <div class="dropdown-divider" />
                            </template>
                            <button type="button" class="dropdown-item logout" @click="logout">Выйти</button>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <Link href="/login" class="btn-auth header-actions__desktop">Войти</Link>
                </template>

                <button
                    type="button"
                    class="header-more-btn"
                    aria-label="Открыть меню"
                    @click="$emit('open-more')"
                >
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
                    </svg>
                </button>
            </div>
        </div>
    </header>
</template>

<script setup>
import { Link, router, usePage } from '@inertiajs/vue3';
import { ref, computed, onMounted, onUnmounted } from 'vue';

defineEmits(['open-more']);

const showUserMenu = ref(false);
const page = usePage();
const authUser = computed(() => page.props.auth?.user || null);
const brand = computed(() => page.props.seoBrand || 'Волейбол Беларуси');

const isActive = (path) => {
    const currentPath = page.url.split('?')[0];
    if (path === '/') return currentPath === '/';
    return currentPath.startsWith(path);
};

const logout = () => {
    showUserMenu.value = false;
    router.post('/logout', {}, {
        preserveScroll: false,
        preserveState: false,
    });
};

const onDocClick = (e) => {
    const header = document.querySelector('.site-header');
    if (header && !header.contains(e.target)) {
        showUserMenu.value = false;
    }
};

onMounted(() => document.addEventListener('click', onDocClick));
onUnmounted(() => document.removeEventListener('click', onDocClick));
</script>
